import axios, { AxiosRequestConfig } from 'axios';
import { IPOMessage } from '@hylaa-npm/ipod';
import { getStorage } from '@/utils/storage';
import { renewToken, systemUrls } from './login';
import { ERROR_CODE } from './errorCode';
import i18next from 'i18next';
// import store from '@/redux/store';
// import types from '@/redux/type';
// import { PageTypeEnum } from '@/utils/enum';
export const BASEURL = window.config.server_url;

export const http = axios.create({
	baseURL: BASEURL,
	headers: {
		Accept: 'application/json, text/plain, */*',
		Authorization: '',
		'Content-Type': 'application/json',
	},
});

// 添加请求拦截器
/**
 * 1. 无特殊 header: 登录， 获取手机验证码， 忘记密码-重置密码
 */
http.interceptors.request.use((config) => {
	if (config.baseURL !== BASEURL) {
		// delete config.headers.Authorization;
	} else {
		if (config.url !== systemUrls.login) {
			config.headers = {
				...config.headers,
				Accept: 'application/json, text/plain, */*',
				Authorization: getStorage('accessToken'),
				'Content-Type': 'application/json',
			};
		} else {
			config.headers = {
				...config.headers,
				Authorization: '',
				'Content-Type': 'application/json',
			};
		}
	}

	return config;
});

// 添加响应拦截器
http.interceptors.response.use(async (res) => {
	const { code } = res.data;

	switch (code) {
		case 69005:
		case 69201:
			await renewToken(getStorage('refreshToken')).then(() => {
				request(
					res.config?.url ?? '',
					res.config.data ? JSON.parse(res.config.data) : undefined,
					res.config?.method,
				);
			});
			break;
		case 200:
			break;
	}
	return res;
});

export const request = (
	url: string,
	params?: unknown,
	methods = 'post',
	requestConfig?: AxiosRequestConfig,
) => {
	methods = methods.toLocaleLowerCase();
	const projectId = (params as { body?: { projectId?: string } })?.body?.projectId ?? '';
	let reqConfig: AxiosRequestConfig = {
		...requestConfig,
		headers: {
			...requestConfig?.headers,
			projectId,
		},
	};
	const thenCb: (code: number, body: unknown, resolve: (value: unknown) => void) => void = (
		code,
		body,
		resolve,
	) => {
		if (code === 200) resolve(body);
		else {
			if (ERROR_CODE[code]) return IPOMessage.error(ERROR_CODE[code]);
			else {
				if (code === 70603) {
					return IPOMessage.error(
						`${i18next.t('common.timeTips1')}${body}${i18next.t('common.timeTips2')}`,
					);
				}
				// if (code === 69201 || code === 69005) return
				return IPOMessage.error(i18next.t('common.serError'));
			}
		}
	};
	if (methods === 'post') {
		return new Promise((resolve) => {
			// @ts-ignore
			http
				.post(url, params, reqConfig)
				.then((response: { data: { code: number; body: unknown } }) => {
					thenCb(response.data.code, response.data.body, resolve);
				})
				.catch((err: AxiosError) => {
					return IPOMessage.error(i18next.t('common.serError'));
				});
		});
	} else {
		return new Promise((resolve) => {
			// @ts-ignore
			http[methods](url, requestConfig)
				.then((response: { data: { code: number; body: unknown } }) => {
					if (requestConfig?.responseType === 'blob') {
						return resolve(response);
					}
					thenCb(response.data.code, response.data.body, resolve);
				})
				.catch((err: AxiosError) => {
					return IPOMessage.error(i18next.t('common.serError'));
				});
		});
	}
};
